export enum InvoiceStateEnum {
  payment_sent = 'payment_sent',
  unpaid = 'unpaid',
  processing = 'processing',
  pending = 'pending',
}

type InvoiceStateTitleKeys = keyof typeof InvoiceStateTitle
export type InvoiceStateTitleValues = typeof InvoiceStateTitle[InvoiceStateTitleKeys]

export const InvoiceStateTitle: Record<InvoiceStateEnum, string> = {
  [InvoiceStateEnum.payment_sent]: 'dashboard.invoice_state.payment_sent',
  [InvoiceStateEnum.unpaid]: 'dashboard.invoice_state.unpaid',
  [InvoiceStateEnum.processing]: 'dashboard.invoice_state.processing',
  [InvoiceStateEnum.pending]: 'dashboard.invoice_state.pending',
}
